import * as yup from "yup";

export const lcmHealthPlanSchema = (edit = false) =>
  yup.object().shape({
    name: yup.string().required("Required *"),
    auto_assignment: yup.bool().required("Required *"),
    status: yup.string(),
  });
